import { FieldErrors, UseFormRegister } from 'react-hook-form';
import {
  AbsoluteCenter,
  Box,
  Divider,
  Heading,
  VStack,
} from '@chakra-ui/react';
import { EvaluationEvent } from '@keyops-cep/api-client';

import {
  ReadOnlyInputField,
  ValidatedInputField,
} from '../../../components/InputComponents';
import i18n from '../../../utils/i18n';
import { EvaluationEventEditFormData } from '../evaluation-event-edit-form-utils';

type VenueSectionProps = {
  register: UseFormRegister<EvaluationEventEditFormData>;
  errors: FieldErrors<EvaluationEventEditFormData>;
  eventData: EvaluationEvent;
};

const VenueSection = ({ register, errors, eventData }: VenueSectionProps) => {
  return (
    <>
      <Box position="relative" padding="10">
        <Divider />
        <AbsoluteCenter bg="white" px="4">
          <Heading size="md">
            {i18n.t('evaluationEvent.form.venue.title')}
          </Heading>
        </AbsoluteCenter>
      </Box>
      <VStack spacing={4} align="stretch" mb={6}>
        <ReadOnlyInputField
          label={i18n.t('evaluationEvent.form.venue.fields.locationType')}
          value={eventData.locationType}
        />
        <ValidatedInputField
          label={i18n.t('evaluationEvent.form.venue.fields.locationName')}
          registerProps={register('locationName')}
          error={errors.locationName}
        />
        <ValidatedInputField
          label={i18n.t('evaluationEvent.form.venue.fields.address')}
          registerProps={register('address')}
          error={errors.address}
        />
        <ValidatedInputField
          label={i18n.t('evaluationEvent.form.venue.fields.city')}
          registerProps={register('city')}
          error={errors.city}
        />
        <ValidatedInputField
          label={i18n.t('evaluationEvent.form.venue.fields.province')}
          registerProps={register('province')}
          error={errors.province}
        />
        <ValidatedInputField
          label={i18n.t('evaluationEvent.form.venue.fields.postalCode')}
          registerProps={register('postalCode')}
          error={errors.postalCode}
        />
        <ValidatedInputField
          label={i18n.t('evaluationEvent.form.venue.fields.mealType')}
          registerProps={register('mealType')}
          error={errors.mealType}
        />
      </VStack>
    </>
  );
};

export default VenueSection;
